import { Box, Button, Grid, TextField, InputLabel, Autocomplete } from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  drivers,
}) => {
  return (
    <Grid container spacing={2}>
      {/* Driver Autocomplete Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Driver
        </InputLabel>
        <Autocomplete
          disablePortal
          options={drivers}
          getOptionLabel={(option) => option.full_name}
          value={
            filterData.driver_id
              ? drivers.find((d) => d.driver_id === filterData.driver_id)
              : null
          }
          onChange={(_, newValue) => {
            handleChangeFilter("driver_id")(
              null,
              newValue ? newValue.driver_id : ""
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Driver"
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              marginRight: 2,
              textTransform: "none",
              color: "#48505E",
              borderColor: "#E0E0E0",
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleFilter}
            endIcon={<ArrowForward />}
            sx={{
              backgroundColor: "#7152F3",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#5c34fa",
              },
            }}
          >
            Filter
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
